import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const loadResults = createAsyncThunk(
  "results/loadResults",
  async ({userId = "me", page = 1, mustValidateToken = true}, thunkAPI) => {
    try {
      const response = await API(`secure/v4/results/all-results/${userId}/${page}`, {method: "GET", mustValidateToken});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const checkCustomerResults = createAsyncThunk(
  "results/checkCustomerResults",
  async ({userId = "me", page = 1}, thunkAPI) => {
    try {
      const response = await API(`secure/v4/results/all-results/${userId}/${page}`);

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const loadMoreResults = createAsyncThunk("results/loadMoreResults", async ({userId, page}, thunkAPI) => {
  try {
    const response = await API(`secure/v4/results/all-results/${userId}/${page}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadBiomarkersResult = createAsyncThunk("results/loadBiomarkersResult", async (orderId, thunkAPI) => {
  try {
    const response = await API(`secure/results/all-order-results/${orderId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadDoctorRating = createAsyncThunk(
  "results/loadDoctorRating",
  async ({orderId, ratingType}, thunkAPI) => {
    try {
      const response = await API(`secure/results/get-rating/${orderId}/${ratingType}`);

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const updateDoctorRating = createAsyncThunk("results/updateDoctorRating", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/results/update-rating", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadMarkerHistory = createAsyncThunk(
  "results/loadMarkerHistory",
  async ({userId, mustValidateToken}, thunkAPI) => {
    try {
      const response = await API(`secure/v3/results/get-marker-history/${userId}`, {method: "GET", mustValidateToken});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const checkMarkerHistory = createAsyncThunk("results/checkMarkerHistory", async (userId, thunkAPI) => {
  try {
    const response = await API(`secure/v3/results/get-marker-history/${userId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadHealthCategories = createAsyncThunk(
  "results/loadHealthCategories",
  async ({userId, mustValidateToken}, thunkAPI) => {
    try {
      const response = await API(`secure/results/health-categories/${userId}`, {method: "GET", mustValidateToken});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const checkHealthCategories = createAsyncThunk("results/checkHealthCategories", async (userId, thunkAPI) => {
  try {
    const response = await API(`secure/results/health-categories/${userId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadHealthCategoriesUnsecure = createAsyncThunk(
  "results/loadHealthCategoriesUnsecure",
  async (payload, thunkAPI) => {
    try {
      const response = await API("/results/health-categories");

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const loadSupplementsRecommended = createAsyncThunk(
  "results/loadSupplementsRecommended",
  async ({userId, mustValidateToken}, thunkAPI) => {
    try {
      const response = await API(`secure/results/supplements-recommended/${userId}`, {
        method: "GET",
        mustValidateToken,
      });

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const checkSupplementsRecommended = createAsyncThunk(
  "results/checkSupplementsRecommended",
  async (userId, thunkAPI) => {
    try {
      const response = await API(`secure/results/supplements-recommended/${userId}`);

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const getPdf = createAsyncThunk("results/getPdf", async ({resultType, dataType, orderId}, thunkAPI) => {
  try {
    const response = await API(`secure/results/get-pdf/${resultType}/${dataType}/${orderId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getMyFormPdf = createAsyncThunk("results/getMyFormPdf", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/results/get-fhm-pdf", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getMyFormPdfV2 = createAsyncThunk("results/getMyFormPdfv2", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/results/get-myform-pdf", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue({error: true, message: error});
  }
});
